document.addEventListener("DOMContentLoaded", function () {
  const accordionTabs = document.querySelectorAll(
    ".prod-info-accordion__tab-heading"
  );
  accordionTabs.forEach((accordionTab) => {
    // on page load, check for accordions with height auto and set the height to the content height
    //  - This is to ensure the accordion animates shut when clicked
    if (accordionTab.getAttribute("aria-expanded") === "true") {
      const parentAccordion = accordionTab.closest(".prod-info-accordion");
      const contentHeight = parentAccordion.querySelector(
        ".prod-info-accordion__tab-body-inner"
      ).scrollHeight;
      parentAccordion.querySelector(
        ".prod-info-accordion__tab-body-wrapper"
      ).style.height = contentHeight + "px";
    }

    //    add click listener to accordion tab
    accordionTab.addEventListener("click", function () {
      const parentAccordion = accordionTab.closest(".prod-info-accordion");
      const contentWrapper = parentAccordion.querySelector(
        ".prod-info-accordion__tab-body-wrapper"
      );
      const isOpen = accordionTab.getAttribute("aria-expanded") === "true";
      const contentHeight = parentAccordion.querySelector(
        ".prod-info-accordion__tab-body-inner"
      ).scrollHeight;
      isOpen
        ? (contentWrapper.style.height = "0px")
        : (contentWrapper.style.height = contentHeight + "px");
      accordionTab.setAttribute("aria-expanded", !isOpen);
    });

    // on page load, check for nutrition tables and display the one that matches the current selected variant
    const nutritionTables = document.querySelectorAll("[data-nutrition-table]");
    const currentSelectedVariantId = document.querySelector(
      'form[action="/cart/add"] [name="id"]'
    )?.value;

    if (
      document.querySelector(
        '[data-nutrition-table="' + currentSelectedVariantId + '"]'
      ) !== null
    ) {
      document.querySelector(
        '[data-nutrition-table="' + currentSelectedVariantId + '"]'
      ).style.display = "block";
    }

    // when the variant is changed, hide all nutrition tables and display the one that matches the new variant
    document.addEventListener("product:variant:changing", function (evt) {
      // wait for 1 and a half seconds
      // - This is to ensure the nutrition table is displayed after the variant is changed - the theme event for after the variant is changed soesn't work.
      // TODO: remove this setTimeout if possible and establish a better event chain.
      setTimeout(function () {
        nutritionTables.forEach(function (nutritionTable) {
          nutritionTable.style.display = "none";
        });

        const newSelectedVariantId = document.querySelector(
          'form[action="/cart/add"] [name="id"]'
        )?.value;
        // instead of getting the variant ID from the form, lets get it from the url
        const newSelectedVariantIdFromUrl = new URLSearchParams(
          window.location.search
        ).get("variant");
        const table = document.querySelector(
          '[data-nutrition-table="' + newSelectedVariantId + '"]'
        );
        if (table) {
          table.style.display = "block";
        }
      }, 1500);
    });
  });

  // add event listener to the 'product-details__nutrition-link' link
  const nutritionLinks = document.querySelectorAll("[data-nutrition-link]");
  nutritionLinks.forEach(function (nutritionLink) {
    nutritionLink.addEventListener("click", function () {
      const accordionTab = document.querySelector(
        "#product-info-accordion .table-wrapper"
      );
      // scroll to element with 100px offset from top
      const elementTop =
        accordionTab.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementTop - 180;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      const accordionTabWrapper = accordionTab.closest(".prod-info-accordion");
      const accordionTabHeading = accordionTabWrapper.querySelector(
        ".prod-info-accordion__tab-heading"
      );
      if (accordionTabHeading?.getAttribute("aria-expanded") === "false") {
        accordionTabHeading.click();
      }
    });
  });

  // find the second section inside the main
  const secondSection = document.querySelector("main section:nth-of-type(2)");

  let sectionPosition = "desktop";

  function moveInfoSection() {
    //check screen size
    if (window.innerWidth < 960 && sectionPosition === "desktop") {
      // find element with id info-placeholder-for-mobile
      const infoPlaceholder = document.querySelector(
        "#info-placeholder-for-mobile"
      );

      // if infoPlaceholder exists, move the secondSection inside of it
      if (infoPlaceholder) {
        // remove class from secondSection - section-inner
        const sectionInner = secondSection.querySelector(
          ".section-inner--width-page-width"
        );
        sectionInner.classList.remove("section-inner");
        sectionInner.classList.add("tw:pb-8");
        infoPlaceholder.appendChild(secondSection);
        sectionPosition = "mobile";
      }
    } else if (window.innerWidth >= 960 && sectionPosition === "mobile") {
      // move it back to it's original position in the second position of the main
      main.insertBefore(secondSection, main.children[1]);
      // add class to secondSection - section-inner
      const sectionInner = secondSection.querySelector(
        ".section-inner--width-page-width"
      );
      sectionInner.classList.add("section-inner");
      sectionInner.classList.remove("tw:pb-8");
      sectionPosition = "desktop";
    }
  }

  // on load, check if screen is less that 960px
  if (window.innerWidth < 960) {
    moveInfoSection();
  }

  // onresize, check if screen is less that 960px
  window.addEventListener("resize", function () {
    moveInfoSection();
  });
});
